import { FETCH_CAT_UP_DATA } from "../constants/endpoints";
import axiosClient from "./axios";

class catUpService {
  static async fetchCatUpData(
    page: number,
    limit: number,
    status: string,
    barcode: string,
    domain: string,
    isApproved: boolean,
    createdAt: string,
    modifiedAt: string,
    productName: string,
    shopId: string
  ) {
    const filters = {
      status: status !== null ? status : undefined,
      barcode: barcode !== null ? barcode : undefined,
      domain: domain !== null ? domain : undefined,
      isApproved: isApproved !== null ? isApproved : undefined,
      productName: productName !== null ? productName : undefined,
      shopId: shopId !== null ? shopId : undefined,
    };
    const sort = {
      createdAt: createdAt !== null ? createdAt : undefined,
      modifiedAt: modifiedAt !== null ? modifiedAt : undefined,
    };
    const response = await axiosClient.post(FETCH_CAT_UP_DATA, {
      page,
      limit,
      filters,
      sort,
    });
    return response;
  }
}

export default catUpService;
